import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBackspace,
  faBullhorn,
  faCheck,
  faSpinner,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

export default function initFontFontAwesome() {
  library.add(faCheck, faTimes, faSpinner, faBackspace, faBullhorn);
}



// WEBPACK FOOTER //
// ./src/init/font-awesome.ts